import { render, staticRenderFns } from "./courseTime.vue?vue&type=template&id=25ced00b&scoped=true&"
import script from "./courseTime.vue?vue&type=script&lang=ts&"
export * from "./courseTime.vue?vue&type=script&lang=ts&"
import style0 from "./courseTime.vue?vue&type=style&index=0&id=25ced00b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ced00b",
  null
  
)

export default component.exports